import { InvoiceCollectionI, StatusCountsI } from '../types/api/InvoiceCollection'
import Invoice from './Invoice'
import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'

export default class InvoiceCollection {
  invoices: Invoice[]
  numreturned: number
  startnumber: number
  totalresults: number
  statusCounts: StatusCountsI
  constructor(invoiceResponse: InvoiceCollectionI) {
    this.invoices = invoiceResponse.invoices?.map(invoice => new Invoice(invoice)) || []
    this.numreturned = invoiceResponse.numreturned
    this.startnumber = invoiceResponse.startnumber
    this.totalresults = invoiceResponse.totalresults
    this.statusCounts = invoiceResponse.statusCounts ?? {}
    ObjectCreationValidator.validate(this)
  }

  get hasUnpaidInvoices() {
    if (!this.invoices) return false
    return this.invoices.some(invoice => invoice.status === 'Unpaid')
  }
}
